import React from "react";
import { TabMenuContainer } from "../styled/common";

const Menu = ({ tabChange, tabs, active, isCreate = false }) => {
  return (
    <TabMenuContainer>
      <ul>
        {tabs.map((ele, idx) =>
          ele ? (
            <li onClick={() => tabChange(idx)} className={active === idx ? "active" : "inactive"}>
              {ele.label}
            </li>
          ) : null,
        )}
      </ul>
      {isCreate && (
        <button onClick={() => tabChange(2)} className={active === 2 ? "active" : "inactive"}>
          피드작성
        </button>
      )}
    </TabMenuContainer>
  );
};

export default Menu;
